import { PayoutAsset, PayoutStatus } from "./cryptoPayoutsSlice";

// User-facing vocabulary is deliberately reduced to SIX states:
// Pending / Processing / Under Review / Completed / Failed / Cancelled.
// Internal stages (submitted_to_vaultody, broadcast_pending, ...) never leak.
export const STATUS_LABEL: Record<PayoutStatus, string> = {
  queued: "Pending",
  awaiting_balance: "Pending",
  awaiting_approval: "Under Review",
  submitted_to_vaultody: "Processing",
  broadcast_pending: "Processing",
  broadcasted: "Processing",
  confirmed: "Completed",
  failed: "Failed",
  manual_review: "Under Review",
  cancelled: "Cancelled",
  reversed: "Cancelled",
};

export const STATUS_CLASS: Record<PayoutStatus, string> = {
  queued: "bg-yellow-500/15 text-yellow-400",
  awaiting_balance: "bg-yellow-500/15 text-yellow-400",
  awaiting_approval: "bg-blue-500/15 text-blue-400",
  submitted_to_vaultody: "bg-amber-500/15 text-amber-400",
  broadcast_pending: "bg-amber-500/15 text-amber-400",
  broadcasted: "bg-amber-500/15 text-amber-400",
  confirmed: "bg-green-500/15 text-green-400",
  failed: "bg-red-500/15 text-red-400",
  manual_review: "bg-blue-500/15 text-blue-400",
  cancelled: "bg-gray-500/15 text-gray-300",
  reversed: "bg-gray-500/15 text-gray-300",
};

const ASSET_LABEL: Record<PayoutAsset, string> = {
  BTC: "Bitcoin (BTC)",
  LTC: "Litecoin (LTC)",
  DOGE: "Dogecoin (DOGE)",
  ETH: "Ethereum (ETH)",
  USDT_ERC20: "USDT (ERC-20)",
  USDT_TRC20: "USDT (TRC-20)",
};

export const assetLabel = (a: PayoutAsset) => ASSET_LABEL[a] ?? a;

// Short unit label for amount rows (e.g. "USDT", "BTC").
export const assetUnit = (a: PayoutAsset) => (a?.startsWith("USDT") ? "USDT" : a);

export const fmtUsd = (n: number) =>
  `$${Number(n).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
export const fmtNaira = (n: number) => `₦${Number(n).toLocaleString()}`;
